import { useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { useContext, useEffect } from 'react';

// LAYOUTS
import NavbarLayout from './layout/navbar/NavbarLayout';
import Footer from './layout/footer/Footer';
import MobileBottomBar from './layout/bottom-bar/MobileBottomBar';

// CONTEXTS
import { UserContext } from './context/user/UserContext';

// MODALS
import ApprovalPendingModal from './modals/ApprovalPendingModal';

// CONFIG & UTILS
import AppRoutes from './AppRoutes';
import { logAnalyticsEvent } from './config/firebase';
import ScrollToTop from './ui/ScrollToTop';
import TopProgressBar from './ui/TopProgressBar';
import { toasterConfig } from './config/toaster.config';
import LogoutLoader from './ui/LogoutLoader';

function App() {
  const location = useLocation();
  const { loggedIn, isLoggingOut } = useContext(UserContext);

  useEffect(() => {
    logAnalyticsEvent('page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location]);

  // Layout logic for dynamic hiding
  const hideFooterRoutes = ['/messages', '/feed'];
  const shouldHideFooter = hideFooterRoutes.some((path) =>
    location.pathname.startsWith(path)
  );

  return (
    <>
      <ScrollToTop />
      <TopProgressBar />
      
      {/* Global Logout Loader */}
      <LogoutLoader isOpen={isLoggingOut} />

      {/* Global Toast Management */}
      <Toaster {...toasterConfig} />
      
      <NavbarLayout />
      
      <main className="min-h-[80vh]">
        <AppRoutes />
      </main>

      {/* Global State-Driven Modals */}
      <ApprovalPendingModal />

      {/* DYNAMIC LAYOUTS */}
      {loggedIn && <MobileBottomBar />}
      {!shouldHideFooter && <Footer />}
    </>
  );
}

export default App;
